export default {
  FILTERS: state => state.filters,
  STAGES: state => state.stages,
  STAGE_BY_ID: state => stageId => state.stages.find(stage => stage._id.toString() === stageId.toString()),
  STAGE_BY_NAME: state => stageName => state.stages.find(stage => stage.name.toString() === stageName.toString()),
  ROWS: state => state.rows,
  BOARD_NAME: state => state.boardName,
  EVENTS: state => state.events,
  GET_EMANDAMENTO_STATUS: state => state.filters.emandamento,
  GET_EMANDAMENTO_META_STATUS: state => state.filters.meta
}



// WEBPACK FOOTER //
// ./src/view/board/state/getters.js